<template>
  <div class="link-views no-bg">
    <div class="bg-div" style="margin-bottom:20px;">
      <span style="display:none;">{{isExpID}}</span>
      <div class="top">
        <router-link :to="{name:'virtualLab'}">
          <Button type="primary">返回</Button>
        </router-link>
      </div>
      <Row :gutter="16" class="hasImgDiv" type="flex">
        <i-col :xs="24" :sm="24" :md="24" :lg="8" :xxl="6">
          <div class="flImg" v-if="virtualDetails.ExpPicUrl!=null">
            <img :src="port+virtualDetails.ExpPicUrl" alt>
          </div>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="16" :xxl="18" class="flex-column">
          <div>
            <strong class="p10">{{virtualDetails.ExpName}}</strong>
          </div>
          <div class="flexDiv flex1">
            <div>实验简介</div>
            <div class="flex1">
              <div>{{virtualDetails.Abstract}}</div>
            </div>
          </div>
          <div class="btnBox">
            <Button
              v-if="virtualDetails.DirVideoUrl"
              @click="showModalVideoUrl=true"
              type="primary"
            >教学引导视频</Button>

            <Tooltip v-else content="当前实验暂无文档">
              <Button type="primary">教学引导视频</Button>
            </Tooltip>

            <router-link :to="{name:'studyMaterials',params:{id:$route.params.id}}">
              <Button type="primary">学习资料</Button>
            </router-link>

            <a href="javascript:void(0)" @click="enterExpUrl(isExpID)">
              <Button type="primary">进入实验</Button>
            </a>
            <Button type="primary" @click="isEnterReport(isExpID)">
              <span style="display:none">{{isExpID}}</span>实验报告
            </Button>
          </div>
        </i-col>
      </Row>
    </div>
    <Row :gutter="16" class="virtualLab" type="flex">
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item1.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">学习总时长（min）</div>
            <div class="big theme">{{LenTime?LenTime:0}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item2.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">学习进度</div>
            <div class="big theme">{{Counts?Counts:'0/0'}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item3.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">日常练习最高分</div>
            <div class="big theme">{{MaxP?MaxP:0}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item4.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">最高的分（考核模式）</div>
            <div class="big theme">{{MaxE?MaxE:0}}</div>
          </div>
        </div>
      </i-col>
    </Row>
    <Row type="flex" :gutter="16" class="virtualLabEchact">
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="bg-div" style="margin-bottom:20px;">
          <div class="title">成绩曲线图</div>
          <div class="echact">
            <ve-line
              :grid="{left:16,right:16}"
              :data="chartData1"
              :judge-width="true"
              :settings="chartSettings1"
              :extend="chartExtend1"
              :data-empty="dataEmpty1"
            ></ve-line>
          </div>
        </div>
        <div class="bg-div">
          <div class="title">时长曲线图</div>
          <div class="echact">
            <ve-line
              :grid="{left:16,right:16}"
              :data="chartData2"
              :judge-width="true"
              :settings="chartSettings2"
              :extend="chartExtend2"
              :data-empty="dataEmpty2"
            ></ve-line>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="flexDiv bg-div" style="height:100%;">
          <div class="timeSide">
            <div class="title">完成时间</div>
            <ul class="timelist" v-if="virtualDetails.Times.length>0">
              <li
                v-for="(item,index) in virtualDetails.Times"
                :key="index"
                @click="changeActive(index)"
              >
                <span :class="{'theme':activeIndex==index}">{{item.EndTime}}</span>
              </li>
            </ul>
            <div v-else class="m10 text-center">暂无错误步骤</div>
          </div>
          <div class="flex1">
            <div class="title">错误步骤记录</div>
            <ul class="steplist" v-if="activeItem.length>0">
              <li v-for="(item,index) in activeItem" :key="index">{{item}}</li>
            </ul>
            <div v-else class="m10 text-center">暂无错误步骤</div>
          </div>
        </div>
      </i-col>
    </Row>
    <div class="bg-div grade">
      <!-- 头部 -->
      <div class="gradeTitle">
        综合评价
        <span class="ml">
          <Rate v-model="gradeListObj.Mean" disabled/>
        </span>
      </div>
      <!-- 评价列表 -->
      <div class>
        <div v-if="gradeListObj.records>0">
          <div class="p10 gradeInfo" v-for="(item,index) in gradeListObj.Result" :key="index">
            <div class="leftSide">
              <div class="text-overflow">{{item.UserName}}</div>
              <div class="rate">
                <Rate disabled v-model="item.DisScore"/>
              </div>
            </div>
            <div class="rightSide">
              <div class="info small">{{item.Content}}</div>
              <div class="time">{{item.CreateTime}}</div>
            </div>
          </div>
        </div>
        <div v-else class="nodata m10">暂无留言</div>
      </div>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          v-if="gradeListObj.records>gradePageData.size"
          show-total
          :total="gradeListObj.records"
          :current="gradePageData.page"
          :page-size="gradePageData.size"
          @on-change="gradechangePage"
        />
      </div>
      <!-- 评分 -->
      <div class="evaluate-div">
        <div class="gradeTitle">综合评价</div>
        <div class="p10 gradeInfo">
          <div class="leftSide">
            <div class="num">{{submitObj.DisScore}}</div>
            <div class="rate">
              <Rate v-model="submitObj.DisScore"/>
            </div>
          </div>
          <div class="rightSide onlyRate">
            <Rate v-model="submitObj.DisScore" @on-change="changeDisScore"/>
          </div>
        </div>
      </div>
      <!-- 评语 -->
      <div class="top">
        <Input v-model="submitObj.Content" type="textarea" :rows="4" placeholder="欢迎留言..."/>
      </div>
      <div class="text-right">
        <i-button type="primary" @click="submitFn">提交</i-button>
      </div>
    </div>
    <Modal v-model="showModalVideoUrl" :mask-closable="false" title="视频" :closable="false">
      <video
        id="vide"
        v-if="virtualDetails.DirVideoUrl!=null&&virtualDetails.DecVideoUrl!=''"
        :src="port+virtualDetails.DirVideoUrl"
        style="width:100%"
        controls
      ></video>
      <div slot="footer">
        <Button  type="text" @click="changeVideoUrl">取消</Button>
      </div>
    </Modal>
  </div>
</template>


<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/student-api.js";
import * as publicApi from "../../../api/public-api.js";
export default {
  name: "item",
  data() {
    this.chartExtend1 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            "第" +
            params[0].axisValue +
            "次成绩：<br/>" +
            params[0].data[1] +
            "分"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings1 = {
      area: true
    };
    this.chartExtend2 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            "第" +
            params[0].axisValue +
            "次时长：<br/>" +
            params[0].data[1] +
            "min"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings2 = {
      area: true
    };
    return {
      port: homeConst.baseUrl + "/", //baseurl
      ExpID: 0,
      virtualDetails: {
        Times: []
      },

      chartData1: {},
      chartData2: {},
      dataEmpty1: true,
      dataEmpty2: true,
      Counts: "",
      LenTime: 0,
      MaxE: 0,
      MaxP: 0,
      gradePageData: {
        ExpID: "",
        page: 1,
        size: 4
      },
      gradeListObj: {
        Result: []
      },
      submitObj: {
        ExpID: null,
        DisScore: 0,
        Content: ""
      },
      activeIndex: 0,
      activeItem: [],
      showModalVideoUrl: false
    };
  },
  mounted() {
    this.ExpID = this.$route.params.id;
    this.submitObj.ExpID = this.$route.params.id;
  },
  watch: {
    ExpID(val) {}
  },
  computed: {
    isExpID() {
      this.ExpID = this.$route.params.id;
      this.submitObj.ExpID = this.$route.params.id;
      this.getItemById(this.ExpID);
      this.GetDiscussList(this.ExpID);
      return this.$route.params.id;
    }
  },
  methods: {
    goback() {
      this.$router.push({
        name: `virtualLab`
      });
    },
    // 获取当前项目// 获取虚拟信息统计;
    getItemById(ExpID) {
      homeApi
        .GetExperiment({
          ExpID: ExpID
        })
        .then(res => {
          if (res.success) {
            this.virtualDetails = res;

            if (this.virtualDetails.Times.length > 0) {
              this.activeItem = this.virtualDetails.Times[0].State;
            } else {
              this.activeItem = [];
            }
            var ScoreList = res.ScoreList.reverse();
            if (res.ScoreList.length > 0) {
              var newScoreList = ScoreList.map((item, index) => {
                return { 次数: index + 1 + "", 分数: item };
              });
              this.chartData1 = {
                columns: ["次数", "分数"],
                rows: newScoreList
              };
              this.dataEmpty1 = false;
            } else {
              this.dataEmpty1 = true;
              this.chartData1 = {};
            }
            var LenTimeList = res.LenTimeList.reverse();
            if (res.LenTimeList.length > 0) {
              var newLenTimeList = LenTimeList.map((item, index) => {
                return { 次数: index + 1 + "", 时长min: item };
              });
              this.chartData2 = {
                columns: ["次数", "时长min"],
                rows: newLenTimeList
              };
              this.dataEmpty2 = false;
            } else {
              this.dataEmpty2 = true;
              this.chartData2 = {};
            }
            this.Counts = res.TJ.Counts;
            this.LenTime = res.TJ.LenTime;
            this.MaxE = res.TJ.MaxE;
            this.MaxP = res.TJ.MaxP;
          }
        });
    },
    //进入实验链接
    enterExpUrl(ExpID) {
      var newWindow = window.open();
      publicApi.GetExpUrl({ ExpID: ExpID }).then(res => {
        var enterExpUrlHref;
        if (res.ExpUrl) {
          if (res.ExpUrl.indexOf("http") == -1) {
            enterExpUrlHref = this.port + res.ExpUrl + "?token=" + res.ExpToken;
          } else {
            enterExpUrlHref = res.ExpUrl + "?token=" + res.ExpToken;
          }
        }
        newWindow.location.href = enterExpUrlHref;
      });
    },
    // 判断是否可进入理论报告
    isEnterReport(ExpID) {
      homeApi.GetExpReport({ ExpID: ExpID }).then(res => {
        if (res.success) {
          this.$router.push({
            name: `labReport`,
            params: { id: ExpID, sub: "item" }
          });
        } else {
          this.$Message.error({
            content: res.msg,
            duration: 3
          });
        }
      });
    },
    // 评语列表
    GetDiscussList(ExpID) {
      publicApi
        .GetDiscussList({
          ExpID: ExpID,
          page: this.gradePageData.page ? this.gradePageData.page : 1,
          size: this.gradePageData.size
        })
        .then(res => {
          this.gradeListObj = res;
        });
    },
    // 评分分页
    gradechangePage(page) {
      this.gradePageData.page = page;
      this.GetDiscussList(this.ExpID);
    },
    // 获取评分值
    changeDisScore(val) {
      this.submitObj.DisScore = val;
    },
    // 添加评分
    submitFn() {
      if (this.submitObj.DisScore > 0 && this.submitObj.Content) {
        publicApi.AddDiscuss(this.submitObj).then(res => {
          this.gradePageData.page = 1;
          this.GetDiscussList(this.ExpID);
          this.$Message.success({
            content: res.msg,
            duration: 3
          });
        });
      } else {
        this.$Message.error({
          content: "评分及评语不能为空",
          duration: 3
        });
      }
    },
    // 错误步骤
    changeActive(num) {
      this.activeIndex = num;
      this.activeItem = this.virtualDetails.Times[num].State;
    },
    // 关闭弹框
    changeVideoUrl() {
      var vide = document.getElementById("vide");
      vide.pause();
      this.showModalVideoUrl = false;
    }
  }
};
</script>

<style scoped>

</style>